let _layer = null;

export function setLayer(layer) {
    _layer = layer;
}

export function getLayer() {
    return _layer;
}
